import PropTypes from 'prop-types';
import RetryButton from './RetryButton';
import { classes } from '@/helpers/styling';
import Text, { FONT_SIZE_070 } from '@/components/component-library/Text';

const ErrorWidget = ({
  onRetry,
  className,
  shouldDisplay,
  errorMessage,
  hideDefaultErrorMessage
}) => {
  const defaultErrorMessage = 'An error occurred';

  return shouldDisplay && (
    <div className={ classes('error-component', className) }>
      { !hideDefaultErrorMessage && (
        <Text
          className={ classes('error-text', {
            '--no-margin': !onRetry,
            '--less-margin': hideDefaultErrorMessage
          }) }
          size={ FONT_SIZE_070 }
          useHeaderFont
        >
          { defaultErrorMessage }
        </Text>
      ) }
      { errorMessage && (
        <Text
          className={ classes('error-text', {
            '--no-margin': !onRetry,
            '--more-margin': !hideDefaultErrorMessage
          }) }
          size={ FONT_SIZE_070 }
          useHeaderFont
        >
          { errorMessage }
        </Text>
      ) }
      { onRetry && (
        <RetryButton onRetry={ onRetry } />
      ) }
    </div>
  );
};

ErrorWidget.propTypes = {
  onRetry: PropTypes.func,
  className: PropTypes.string,
  errorMessage: PropTypes.string,
  hideDefaultErrorMessage: PropTypes.bool,
  shouldDisplay: PropTypes.bool
};

ErrorWidget.defaultProps = {
  onRetry: undefined,
  className: '',
  errorMessage: '',
  hideDefaultErrorMessage: false,
  shouldDisplay: false
};

export default ErrorWidget;
